import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import * as serviceWorker from "serviceWorker";
import { Provider } from "react-redux";
import configureStore from "./config/store.js";
import { BREAKPOINTS } from "config/breakpoints";
import { BrowserRouter } from "react-router-dom";
import { WindowManager } from "react-window-decorators";
import App from "./App";
import "scss/index.scss";

new WindowManager(BREAKPOINTS);

const store = configureStore();

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
